import React, { useEffect, useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import swal from "sweetalert"
import { useAppDispatch } from "../../app/hooks"
import { loadAllRejectReasons, loadPurchaseRequest, markAsPurchased } from "../../store/purchaseRequest.store"

const PurchaseModal = (props: any) => {
    const { t, i18n } = useTranslation()
    const [purchaseRequest, setPurchaseRequest] = useState(props.modalRow)
    const [pictureBase64, setPictureBase64] = useState<any | null>(null)
    const [attachedPicture, setAttachedPicture] = useState({})
    const [attachedPictureName, setAttachedPictureName] = useState<any | null>(null)
    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const [error, setError] = useState<any | null>(null)
    const [showError, setShowError] = useState<boolean>(false)
    const dispatch = useAppDispatch()

    useEffect(() => {
        setPurchaseRequest(props.modalRow)
        setAttachedPictureName("")
    }, [props.modalRow])
    const onFormSubmit = async (e: any) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const formDataObj: any = Object.fromEntries(formData.entries())
        const fileData = formDataObj.file
        if (!fileData.name) {
            setShowError(true)
        } else {
            var data: any = {
                purchase_request_id: props.modalRow.id,
                proof_of_purchase: pictureBase64,
                transfer_balance_amount_to_wallet: props.totalPriceData < props.modalRow.total_amount ? 1 : 0,
                final_amount: props.totalPriceData
            }
            var purchased: any = await dispatch(markAsPurchased(data))
            if (purchased?.payload?.data && purchased?.payload?.data?.status === true) {
                swal({
                    title: "",
                    text: t("Purchase_Is_confirmed"),
                    icon: "success"
                }).then(function () {
                    props.viewModalClose()
                    dispatch(loadPurchaseRequest())
                    dispatch(loadAllRejectReasons())
                })
            } else {
                swal({
                    title: "",
                    text: t("Purchase_Is_not_confirmed"),
                    icon: "error"
                }).then(function () {
                    props.viewModalClose()
                    dispatch(loadPurchaseRequest())
                    dispatch(loadAllRejectReasons())
                })
            }
        }
    }
    const HandleBrowseClick = (event: any) => {
        if (event && hiddenFileInput && hiddenFileInput.current) hiddenFileInput.current.click()
    }
    const handleFile = (event: any) => {
        try {
            let files = event.target.files
            let reader = new FileReader()
            reader.readAsDataURL(files[0])

            reader.onload = (e) => {
                setAttachedPicture(files[0])
                setAttachedPictureName(files[0]?.name)
                setPictureBase64(reader.result)
            }
            setShowError(false)
        } catch (e: any) {
            setError(e.message)
        }
    }
    return (
        <Modal
            show={props.show}
            onHide={props.viewModalClose}
            dialogClassName={i18n.language + " purchase-request-modal"}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={"gray-bg"}
            centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="px-4 mb40 py-0">
                <Form noValidate onSubmit={onFormSubmit} className="form">
                    <div>
                        <h4 className="mb-3 modal-heading">{t("Mark_As_Purchased")}</h4>
                        <p className="modal-description pb-3">{t("Purchased_Modal_Description")}</p>
                        <Row className="w-100 mb-2">
                            <Col className="label required">{t("Invoice_of_purchase")}</Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="d-flex mb-2">
                                    <div className="browse-field">{attachedPictureName}</div>
                                    <input
                                        type="button"
                                        value="Browse"
                                        id="fakeBrowse"
                                        className="browse-button"
                                        onClick={HandleBrowseClick}
                                    />
                                </div>
                                <input
                                    id="fileCustomBrowse"
                                    ref={hiddenFileInput}
                                    name="file"
                                    type="file"
                                    onChange={handleFile}
                                    className="form-control-file upload-button d-none"
                                />
                                <div className={showError ? "show error" : "hide error"}>
                                    {t("upload_image_error")}
                                </div>
                            </Col>
                        </Row>
                        <Row className="my-2">
                            <Col>
                                <Button type="submit" className="w-100  py-1 transfer-wallet">
                                    {t("Confirm")}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    )
}
export default PurchaseModal
